import {SET_WIX_DATA, SET_ITEMS, SET_RENDERED_ITEMS_COUNT,
  VIDEO_ENDED, VIDEO_ADDED, GALLERY_WINDOW_LAYOUT_CHANGED, VIDEO_PLAY_MODE, NAVIGATION_IN, EDITOR_MODE_CHANGED} from '../constants/galleryTypes.js'
import {PLAY_VIDEO, PAUSE_VIDEO} from '../actions/itemViewActions.js';
import initialState from './initialState.js';

import _ from 'lodash'
import {utils} from '../utils'

export default function galleryReducer(state = initialState.gallery, action) {
  var isAutoPlayMode = () => state.videoPlayMode !== 'auto' || utils.isEditor();

  switch (action.type) {
    case SET_WIX_DATA:
      if (action.boundingRectAndOffsets) {
        var res = action.boundingRectAndOffsets;
        var scrollBase = res.offsets.y;
        var scrollTop = ( (-1) * res.rect.top) / utils.getViewportScaleRatio();
        var maxGalleryWidth;
        if (res && res.rect && !_.isUndefined(res.rect.width)) {
          maxGalleryWidth = res.rect.width;
        }

        return _.merge({}, state,  {
          wixInit: true,
          scrollBase: scrollBase,
          scrollTop: scrollTop,
          maxGalleryWidth: maxGalleryWidth
        });

      } else {
        return _.merge({}, state,  {
          wixInit: true,
          scrollBase: 0
        });
      }

    case SET_ITEMS:
      return _.merge({}, state,  {items: action.items});

    case SET_RENDERED_ITEMS_COUNT:
      return _.merge({}, state,  {renderedItemsCount: action.count});

    case VIDEO_PLAY_MODE:
      return _.merge({}, state,  {videoPlayMode: action.videoPlayMode});

    case VIDEO_ADDED:
      return isAutoPlayMode() || state.videoIndexPlay !== -1 ? state : _.merge({}, state,  {videoIndexPlay: action.videoIndexAutoPlay});

    case GALLERY_WINDOW_LAYOUT_CHANGED:
      const documentHeight = {documentHeight: action.documentHeight};
    case NAVIGATION_IN:
    case VIDEO_ENDED:
      return isAutoPlayMode() ? state : _.merge({}, state, {videoIndexPlay: action.videoIndexAutoPlay}, documentHeight);

    case EDITOR_MODE_CHANGED:
      const videoIndexPlay = state.videoPlayMode == 'auto' ? action.videoIndexAutoPlay : -1
      return _.merge({}, state, {videoIndexPlay});

    case PLAY_VIDEO:
      return _.merge({}, state,  {videoIndexPlay: action.idx});

    case PAUSE_VIDEO:
      return _.merge({}, state,  {videoIndexPlay: -1});

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/galleryReducer.js